export const BASE_API = process.env.VUE_APP_BASE_API

export const GB_PRIME_URL = process.env.VUE_APP_GB_PRIME_BASE_API
export const GB_PRIME_PUBLIC_KEY = process.env.VUE_APP_GB_PRIME_PUBLIC_KEY
export const GB_PRIME_CUSTOMER_KEY = process.env.VUE_APP_GB_PRIME_CUSTOMER_KEY
